module.exports = __webpack_public_path__ + "img/0e.4c55127b.png";